@if (message) {
  <p class="field__error" role="alert">{{ message }}</p>
}

<!-- One table, one row per client. Narrow, each row stacks into a block: the column headings hide and each tick and the Can see choice show their own label. -->
<table class="table client-user-access__links">
  <thead>
    <tr class="client-user-access__head">
      <th scope="col">Client</th>
      <th scope="col" class="client-user-access__tick-col">Admin</th>
      <th scope="col" class="client-user-access__tick-col">Custodian</th>
      <th scope="col" class="client-user-access__tick-col">Reports</th>
      @if (accessVisible) {
        <th scope="col" class="client-user-access__can-see-col">Can see</th>
        <th scope="col" class="client-user-access__last-changed-col">Last changed</th>
      }
    </tr>
  </thead>
  <tbody>
    @for (row of rows; track row.clientId) {
      <tr class="client-user-access__row">
        <td class="client-user-access__client">{{ row.clientName }} ID: {{ row.clientId }}</td>
        <td class="client-user-access__tick">
          @if (row.client) {
            <label class="field__checkbox"><input type="checkbox" [checked]="row.client.isAdmin" [attr.aria-label]="'Admin at ' + row.clientName" (change)="changeRole(row.client, $event, 'ADMIN')" /><span class="client-user-access__tick-label">Admin</span></label>
          }
        </td>
        <td class="client-user-access__tick">
          @if (row.client) {
            <label class="field__checkbox"><input type="checkbox" [checked]="row.client.isCustodian" [attr.aria-label]="'Custodian at ' + row.clientName" (change)="changeRole(row.client, $event, 'CUSTODIAN')" /><span class="client-user-access__tick-label">Custodian</span></label>
          }
        </td>
        <td class="client-user-access__tick">
          @if (row.client) {
            <label class="field__checkbox"><input type="checkbox" [checked]="row.client.isReport" [attr.aria-label]="'Reports at ' + row.clientName" (change)="changeRole(row.client, $event, 'REPORT')" /><span class="client-user-access__tick-label">Reports</span></label>
          }
        </td>
        @if (accessVisible) {
          <td class="client-user-access__can-see">
            @if (row.link; as link) {
              <!-- The options say what each means; the visible label shows only when the row stacks. -->
              <label class="client-user-access__can-see-field">
                <span class="client-user-access__can-see-label">Can see</span>
                <select class="field__control client-user-access__can-see-select" [value]="optionFor(link)"
                  [attr.aria-label]="'Which bookings ' + personName + ' can see at ' + row.clientName"
                  (change)="chooseWholeClient(link, row.clientName, $any($event.target))">
                  <!-- Static values (CanSeeNamedOnly, CanSeeEveryBooking): the select's [value] binds before any option binding would. -->
                  <option value="named">Only bookings they are named on</option>
                  <option value="every">Every booking at this client</option>
                </select>
              </label>
            }
          </td>
          <!-- The date and time never split; the line breaks between the name and the date instead. -->
          <td class="client-user-access__last-changed" [attr.data-label]="row.link?.lastChangedUtc ? 'Last changed' : null">
            @if (row.link?.lastChangedUtc) {
              {{ row.link.lastChangedBy }}, <span class="tw:whitespace-nowrap">{{ row.link.lastChangedUtc | date: 'dd MMM yyyy HH:mm' }}</span>
            }
          </td>
        }
      </tr>
    }
  </tbody>
</table>

@if (accessVisible) {
  <div class="client-user-access__named-on-block">
    <h4 class="client-user-access__subheading">Named on bookings</h4>
    @if (liveNamedOn.length) {
      <ul class="client-user-access__named-on">
        @for (grant of liveNamedOn; track grant.id) {
          <li>
            Booking {{ grant.placementId }}, {{ grant.clientName }}@if (grant.studentDescription) { ({{ grant.studentDescription }})},
            added by {{ grant.grantedByName }} on {{ grant.grantedDate | date: 'dd MMM yyyy' }}@if (grant.endDate) {, until {{ grant.endDate | date: 'dd MMM yyyy' }}}.
            <button type="button" class="btn btn-link btn-sm client-user-access__open" (click)="openBookingSetup(grant)">Open booking setup</button>
          </li>
        }
      </ul>
    } @else {
      <p class="client-user-access__none">Not named on any booking.</p>
    }
  </div>
}
